export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/opt/buildhome/repo/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/:all(.*)',
    name: '/[...all]',
    component: () => import('/opt/buildhome/repo/src/pages/[...all].vue'),
    /* no children */
  },
  {
    path: '/assets',
    /* internal name: '/assets' */
    /* no component */
    children: [
      {
        path: '',
        name: '/assets/',
        component: () => import('/opt/buildhome/repo/src/pages/assets/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/assets/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/assets/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/character',
    /* internal name: '/character' */
    /* no component */
    children: [
      {
        path: '',
        name: '/character/',
        component: () => import('/opt/buildhome/repo/src/pages/character/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/character/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/character/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/character-template',
    /* internal name: '/character-template' */
    /* no component */
    children: [
      {
        path: '',
        name: '/character-template/',
        component: () => import('/opt/buildhome/repo/src/pages/character-template/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/character-template/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/character-template/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/collection-tasks',
    /* internal name: '/collection-tasks' */
    /* no component */
    children: [
      {
        path: '',
        name: '/collection-tasks/',
        component: () => import('/opt/buildhome/repo/src/pages/collection-tasks/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/collection-tasks/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/collection-tasks/[id].vue'),
        /* no children */
      },
      {
        path: 'new',
        name: '/collection-tasks/new',
        component: () => import('/opt/buildhome/repo/src/pages/collection-tasks/new.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/config',
    /* internal name: '/config' */
    /* no component */
    children: [
      {
        path: '',
        name: '/config/',
        component: () => import('/opt/buildhome/repo/src/pages/config/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/config/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/config/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/developer-keys',
    /* internal name: '/developer-keys' */
    /* no component */
    children: [
      {
        path: '',
        name: '/developer-keys/',
        component: () => import('/opt/buildhome/repo/src/pages/developer-keys/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/developer-keys/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/developer-keys/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/gpu-tasks',
    /* internal name: '/gpu-tasks' */
    /* no component */
    children: [
      {
        path: '',
        name: '/gpu-tasks/',
        component: () => import('/opt/buildhome/repo/src/pages/gpu-tasks/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/gpu-tasks/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/gpu-tasks/[id].vue'),
        /* no children */
      },
      {
        path: 'new',
        name: '/gpu-tasks/new',
        component: () => import('/opt/buildhome/repo/src/pages/gpu-tasks/new.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/opt/buildhome/repo/src/pages/login.vue'),
    /* no children */
    meta: {
      "layout": "auth"
    },
  },
  {
    path: '/pipeline-template',
    /* internal name: '/pipeline-template' */
    /* no component */
    children: [
      {
        path: '',
        name: '/pipeline-template/',
        component: () => import('/opt/buildhome/repo/src/pages/pipeline-template/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/pipeline-template/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/pipeline-template/[id].vue'),
        /* no children */
      },
      {
        path: 'new',
        name: '/pipeline-template/new',
        component: () => import('/opt/buildhome/repo/src/pages/pipeline-template/new.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/profile',
    name: '/profile',
    component: () => import('/opt/buildhome/repo/src/pages/profile.vue'),
    /* no children */
  },
  {
    path: '/prompts',
    /* internal name: '/prompts' */
    /* no component */
    children: [
      {
        path: '',
        name: '/prompts/',
        component: () => import('/opt/buildhome/repo/src/pages/prompts/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/reconmodel-v2',
    /* internal name: '/reconmodel-v2' */
    /* no component */
    children: [
      {
        path: '',
        name: '/reconmodel-v2/',
        component: () => import('/opt/buildhome/repo/src/pages/reconmodel-v2/index.vue'),
        /* no children */
      },
      {
        path: ':version',
        name: '/reconmodel-v2/[version]',
        component: () => import('/opt/buildhome/repo/src/pages/reconmodel-v2/[version].vue'),
        /* no children */
      },
      {
        path: 'new',
        name: '/reconmodel-v2/new',
        component: () => import('/opt/buildhome/repo/src/pages/reconmodel-v2/new.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/reconstruction-v2',
    /* internal name: '/reconstruction-v2' */
    /* no component */
    children: [
      {
        path: '',
        name: '/reconstruction-v2/',
        component: () => import('/opt/buildhome/repo/src/pages/reconstruction-v2/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/reconstruction-v2/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/reconstruction-v2/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/register',
    name: '/register',
    component: () => import('/opt/buildhome/repo/src/pages/register.vue'),
    /* no children */
    meta: {
      "layout": "auth"
    },
  },
  {
    path: '/services',
    /* internal name: '/services' */
    /* no component */
    children: [
      {
        path: '',
        name: '/services/',
        component: () => import('/opt/buildhome/repo/src/pages/services/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/settings',
    name: '/settings',
    component: () => import('/opt/buildhome/repo/src/pages/settings.vue'),
    /* no children */
  },
  {
    path: '/sms-send-logs',
    /* internal name: '/sms-send-logs' */
    /* no component */
    children: [
      {
        path: '',
        name: '/sms-send-logs/',
        component: () => import('/opt/buildhome/repo/src/pages/sms-send-logs/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/task-stats',
    /* internal name: '/task-stats' */
    /* no component */
    children: [
      {
        path: '',
        name: '/task-stats/',
        component: () => import('/opt/buildhome/repo/src/pages/task-stats/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/tasks',
    /* internal name: '/tasks' */
    /* no component */
    children: [
      {
        path: '',
        name: '/tasks/',
        component: () => import('/opt/buildhome/repo/src/pages/tasks/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/tasks/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/tasks/[id].vue'),
        /* no children */
      },
      {
        path: 'new',
        name: '/tasks/new',
        component: () => import('/opt/buildhome/repo/src/pages/tasks/new.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/test-ground',
    /* internal name: '/test-ground' */
    /* no component */
    children: [
      {
        path: '',
        name: '/test-ground/',
        component: () => import('/opt/buildhome/repo/src/pages/test-ground/index.vue'),
        /* no children */
      },
      {
        path: 'rating',
        name: '/test-ground/rating',
        component: () => import('/opt/buildhome/repo/src/pages/test-ground/rating.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/video-materials',
    /* internal name: '/video-materials' */
    /* no component */
    children: [
      {
        path: '',
        name: '/video-materials/',
        component: () => import('/opt/buildhome/repo/src/pages/video-materials/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/video-materials/[id]',
        component: () => import('/opt/buildhome/repo/src/pages/video-materials/[id].vue'),
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

